import { get, includes } from "lodash"
import useResource from "hooks/resources"
import { useModelMetadata } from "resources/models"
import { useResourceMetadata } from "resources/resource"
import { useAccountAlias } from "resources/account"
import { DEFAULT_CURRENCY } from "helpers/formatters/numbers"
import { combineTanStackStatuses } from "helpers/data-statuses"
const EMPTY_ARRAY = []

export function useModelCurrencies(modelId) {
  const account = useAccountAlias()
  return useResource({
    resource: "modelCurrencies",
    url: () => {
      if (!account || !modelId) {
        return null
      }
      return `/api/${account}/m/${modelId}/currencies`
    },
  })
}

export const SUPPORTED_CURRENCIES_QUERY = {
  resource: "supportedCurrencies",
  url: () => "/api/currencies",
}

export function useSupportedCurrencies() {
  return useResource(SUPPORTED_CURRENCIES_QUERY)
}

export function getSupportedCurrencies(state) {
  return get(state, "global.data.supportedCurrencies.data", EMPTY_ARRAY)
}

export function useResourceCurrency(modelId, resource) {
  const { id: resourceId, type: resourceType } = resource || {}
  const [modelMetadata, modelMetadataStatus] = useModelMetadata(modelId)
  const [resourceMetadata, resourceMetadataStatus] = useResourceMetadata(modelId, resourceId, resourceType)
  const status = combineTanStackStatuses([modelMetadataStatus, resourceMetadataStatus])

  const supportedCurrencies = modelMetadata?.supportedCurrencies || EMPTY_ARRAY
  const currency = includes(supportedCurrencies, resourceMetadata?.currencyOverride) ? resourceMetadata?.currencyOverride : DEFAULT_CURRENCY
  return [currency, status]
}
